import { Languages } from 'core/localization/entities';
import { FlowStatus, FunnelStatus } from './FunnelData';

export enum RevalidationAction {
  CREATE_FLOW = 'create.flow',
  UPDATE_FLOW = 'update.flow',
  DELETE_FLOW = 'delete.flow',
  CREATE_FUNNEL = 'create.funnel',
  UPDATE_FUNNEL = 'update.funnel',
  DELETE_FUNNEL = 'delete.funnel',
}

export type RevalidationFlow = {
  id: string;
  name: string;
  status: FlowStatus;
  language: Languages;
  initial_screen: string;
  previous_initial_screen?: string | null;
  previous_language?: Languages | null;
  description: string;
  screens: Array<{ id: string }> | [];
};

type Funnel = {
  id: string;
  name: string;
  status: FunnelStatus;
  description: string;
  link: string;
  flow?: RevalidationFlow;
  flows?: RevalidationFlow[];
};

type Metadata = {
  version: string;
};

type FunnelWithOneFlowPayload = {
  funnel: Funnel & { flow: RevalidationFlow };
};

type FunnelWithAllFlowsPayload = {
  funnel: Funnel & { flows: RevalidationFlow[] };
};

export type RequestFunnelWithAllFlows = {
  id: string;
  action: RevalidationAction;
  timestamp: string;
  payload: FunnelWithAllFlowsPayload;
  metadata: Metadata;
};

export type RequestFunnelWithOneFlow = {
  id: string;
  action: RevalidationAction;
  timestamp: string;
  payload: FunnelWithOneFlowPayload;
  metadata: Metadata;
};
